<div class="grid-6 copo-container footer-margin" *ngIf="segment && segment.tensileList && this.segment.tensileList.length > 0">
	<div class="grid-column-one-full">
		<mat-expansion-panel [expanded]="true" class="card-info-block">
			<mat-expansion-panel-header>
				<mat-panel-title class="card-content-title">
					<span translate>aqdb.mechanical.characteristics.tensile.test</span>
				</mat-panel-title>
			</mat-expansion-panel-header>
			<mat-divider class="margin-expansion-panel"></mat-divider>
			<div class="card-content-block quadruple-column" *ngFor="let tensile of segment.tensileList">
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.test.number.tensile</div>
						<div class="card-content-value">{{ tensile.testNumber ? (tensile.testNumber | copoNumber:'number') : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.tensile.direction</div>
						<div class="card-content-value"> 
							<div *ngIf="tensile.sampleDirectionCode === 'T'">
								<span translate>aqdb.direction.T</span>
							</div>
							<div *ngIf="tensile.sampleDirectionCode === 'L'">
								<span translate>aqdb.direction.L</span>
							</div>
							<div *ngIf="tensile.sampleDirectionCode !== 'T' && tensile.sampleDirectionCode !== 'L'">
								{{ UNDERSCORE }}
							</div>
						</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.pos.across.width</div>
						<div class="card-content-value"> 
							<div *ngIf="tensile.samplePositionAcrossWidth === 'A'">
								<span translate>aqdb.axis</span>
							</div>
							<div *ngIf="tensile.samplePositionAcrossWidth === 'Q'">
								<span translate>aqdb.quarter</span>
							</div>
							<div *ngIf="tensile.samplePositionAcrossWidth !== 'A' && tensile.samplePositionAcrossWidth !== 'Q'">
								{{ UNDERSCORE }}
							</div>
						</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.pos.across.length</div>
						<div class="card-content-value">{{ tensile.samplePositionAlongLength !== null && tensile.samplePositionAlongLength !== undefined ? (tensile.samplePositionAlongLength | copoNumber:'weight') : UNDERSCORE }} </div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.tensile.work.hardening.coefficient</div>
						<div class="card-content-value">{{ tensile.strainHardeningRatio && isDisplayedData(tensile.indTrsValueN) ? (tensile.strainHardeningRatio | copoNumber:'weight') : UNDERSCORE }}
							<span *ngIf="isTransmittedOnCertificateData(tensile.indTrsValueN)" class="transmitted-data-icon"><mat-icon [matTooltip]="'aqdb.datas.transmitted.on.certificate' | translate" color="accent" class="batch-icon" svgIcon="icon-transmitted"></mat-icon></span>
							<span *ngIf="isMeasuredData(tensile.indTrsValueN, tensile.strainHardeningRatioTypdon)"><mat-icon [matTooltip]="'aqdb.measured.datas' | translate" color="accent" class="batch-icon" svgIcon="icon-measured"></mat-icon></span>
							<span *ngIf="isModelledData(tensile.indTrsValueN, tensile.strainHardeningRatioTypdon)"><mat-icon  [matTooltip]="'aqdb.modelled.data' | translate" color="accent" class="batch-icon" svgIcon="icon-modelled"></mat-icon></span>
						</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.yield.stress</div>
						<div class="card-content-value">{{ tensile.valueYs && isDisplayedData(tensile.indTrsYs) ? (tensile.valueYs | copoNumber:'weight') : UNDERSCORE }}
							<span translate>aqdb.mpa.unit</span>
							<span *ngIf="isTransmittedOnCertificateData(tensile.indTrsYs)" class="transmitted-data-icon"><mat-icon [matTooltip]="'aqdb.datas.transmitted.on.certificate' | translate" color="accent" class="batch-icon" svgIcon="icon-transmitted"></mat-icon></span>
							<span *ngIf="isMeasuredData(tensile.indTrsYs, tensile.yieldStrengthTypdon)"><mat-icon [matTooltip]="'aqdb.measured.datas' | translate" color="accent" class="batch-icon" svgIcon="icon-measured"></mat-icon></span>
							<span *ngIf="isModelledData(tensile.indTrsYs, tensile.yieldStrengthTypdon)"><mat-icon  [matTooltip]="'aqdb.modelled.data' | translate" color="accent" class="batch-icon" svgIcon="icon-modelled"></mat-icon></span>
						</div>
					</div>
						<div class="card-content-info">
							<div class="card-content-label" translate>aqdb.test.steel.condition</div>
							<div class="card-content-value">{{ tensile.testSteelCondition ? tensile.testSteelCondition : UNDERSCORE }}</div>
						</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.sample.type</div>
						<div class="card-content-value">{{ tensile.sampleType ? tensile.sampleType : UNDERSCORE }} </div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.tensile.ultimate.tensile.stress</div>
						<div class="card-content-value">{{ tensile.ultimateTensileStrength && isDisplayedData(tensile.indTrsYs) ? (tensile.ultimateTensileStrength | copoNumber:'weight') : UNDERSCORE }}
							<span translate>aqdb.mpa.unit</span>
							<span *ngIf="isTransmittedOnCertificateData(tensile.indTrsYs)" class="transmitted-data-icon"><mat-icon [matTooltip]="'aqdb.datas.transmitted.on.certificate' | translate" color="accent" class="batch-icon" svgIcon="icon-transmitted"></mat-icon></span>
							<span *ngIf="isMeasuredData(tensile.indTrsYs, tensile.ultimateTensileStrengthTypdon)"><mat-icon [matTooltip]="'aqdb.measured.datas' | translate" color="accent" class="batch-icon" svgIcon="icon-measured"></mat-icon></span>
							<span *ngIf="isModelledData(tensile.indTrsYs, tensile.ultimateTensileStrengthTypdon)"><mat-icon  [matTooltip]="'aqdb.modelled.data' | translate" color="accent" class="batch-icon" svgIcon="icon-modelled"></mat-icon></span>
						</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.tensile.total.lengthening</div>
						<div class="card-content-value">{{ tensile.elongation && isDisplayedData(tensile.indTrsPercentATotal) ? (tensile.elongation | copoNumber:'weight') : UNDERSCORE }}
							<span *ngIf="isTransmittedOnCertificateData(tensile.indTrsPercentATotal)" class="transmitted-data-icon"><mat-icon [matTooltip]="'aqdb.datas.transmitted.on.certificate' | translate" color="accent" class="batch-icon" svgIcon="icon-transmitted"></mat-icon></span>
							<span *ngIf="isMeasuredData(tensile.indTrsPercentATotal, tensile.elongationTypdon)"><mat-icon [matTooltip]="'aqdb.measured.datas' | translate" color="accent" class="batch-icon" svgIcon="icon-measured"></mat-icon></span>
							<span *ngIf="isModelledData(tensile.indTrsPercentATotal, tensile.elongationTypdon)"><mat-icon  [matTooltip]="'aqdb.modelled.data' | translate" color="accent" class="batch-icon" svgIcon="icon-modelled"></mat-icon></span>
						</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.tensile.re.rm</div>
						<div class="card-content-value">{{ tensile.valueYs && tensile.ultimateTensileStrength && isDisplayedData(tensile.indTrsYs) ? (getReRmValue(tensile.valueYs, tensile.ultimateTensileStrength) | number) : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.test.condition</div>
						<div class="card-content-value">{{ tensile.testConditions ? tensile.testConditions : UNDERSCORE }}</div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.test.temp</div>
						<div class="card-content-value">{{ tensile.testTemperature ? (tensile.testTemperature | copoNumber:'weight') : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.avg.hardening.ratio</div>
						<div class="card-content-value">{{ tensile.averageStrainHardeningRatio ? (tensile.averageStrainHardeningRatio | copoNumber:'weight') : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.dis.elongation</div>
						<div class="card-content-value">{{ tensile.distributedElongation !== null && tensile.distributedElongation !== undefined ? (tensile.distributedElongation | copoNumber:'weight') : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.level</div>
						<div class="card-content-value">{{ tensile.level !== null && tensile.level !== undefined ? (tensile.level | copoNumber:'number') : UNDERSCORE }}</div>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</div>
</div>
